import * as scssStyles from '$CSS/settings.scss';
import styled from '@emotion/styled';

const GeotabStyledEventType = (fontSize?: string, fontWeight?: string) => {
    return `
    line-height: ${scssStyles.textCardDescriptionLineHeight};
    ${fontSize && 'font-size: ' + fontSize + ';'}
    ${fontWeight && 'font-weight: ' + fontWeight + ';'}
    `;
};

const EncompassStyledEventType = (fontSize: string, fontWeight?: string) => {
    return `
    line-height: 1.1em;
    font-size: ${fontSize};
    ${fontWeight && 'font-weight: ' + fontWeight + ';'}
    height: 1.6em;
    margin-bottom: -3px;
`;
};

type StyledEventProps = {
    fontSize?: string;
    fontWeight?: string;
};

const StyledEventType = styled.div<StyledEventProps>`
    ${(props) => {
        switch (scssStyles.styleEnvironment) {
            case 'geotab':
                return GeotabStyledEventType(props.fontSize, props.fontWeight);
            case 'encompass':
                const fontSize = props.fontSize || '15px';
                return EncompassStyledEventType(fontSize, props.fontWeight);
            default:
                return GeotabStyledEventType();
        }
    }};
`;

export { StyledEventType };
